export const awaitPromise = async <T>(promise: Promise<T>): Promise<T> => await promise;
